// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  z-index: 1060;
}

.modal-header,
.modal-footer {
  border: none;
}

.modal-body {
  display: grid;
  gap: 1.25rem;
  text-align: center;
}

.modal-loader {
  display: grid;
  place-items: center;
  min-height: 160px;
}

.modal-reward {
  position: relative;
  padding: 1rem;
}

.modal-reward__image {
  width: min(220px, 70%);
  margin: 0 auto 1rem;
  display: block;
}

.modal-reward__title {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.modal-reward__desc {
  font-size: 1rem;
  margin-bottom: 1.5rem;
}

.modal-reward__cta {
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.modal-nowin-copy {
  font-size: 1.1rem;
}

.modal-backdrop {
  z-index: 1050;
}

.confetti {
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(212, 0, 0, 0.2), transparent 50%), radial-gradient(circle at 80% 30%, rgba(255, 204, 0, 0.2), transparent 55%), radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.3), transparent 55%);
  mix-blend-mode: screen;
  animation: confettiPulse 2.4s infinite;
}

@keyframes confettiPulse {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
}
.game-container video {
  width: 100%;
  height: 600px;
}
.game-container .play {
  position: absolute;
  left: 0;
  right: 0;
  width: 200px;
  margin: 0 auto;
  bottom: 90px;
  z-index: 900;
}

@media (max-width: 767px) {
  .game-container video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    width: 100% !important;
    height: auto !important;
    z-index: 500;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/advent-calendar/components/reward-modal/reward-modal.component.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;AAFF;;AAcA;;EAEE,YAAA;AAXF;;AAkBA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,sBAAA;EACA,mBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,eAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,qBAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,iBAAA;AAfF;;AAwBA;EACE,aAAA;AArBF;;AAwBA;EACE,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,iPAAA;EAGA,sBAAA;EACA,sCAAA;AAvBF;;AA0BA;EACE;IAEE,YAAA;EAxBF;EA2BA;IACE,YAAA;EAzBF;AACF;AA6BI;EACI,WAAA;EACA,aAAA;AA3BR;AA8BI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AA5BR;;AAiCA;EAOQ;IACI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,WAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;EApCV;AACF","sourcesContent":["@use '../../../../../../assets/styles/colors' as colors;\n@use '../../../../../../assets/styles/bootstrap-essentials';\n\n.modal {\n  z-index: 1060;\n}\n\n.modal-content {\n  // background: rgba(255, 255, 255, 0.95);\n  // color: #d40000;\n  // border-radius: 20px;\n  // border: none;\n  // box-shadow: 0 24px 48px rgba(0, 0, 0, 0.35);\n  // overflow: hidden;\n}\n\n.modal-header,\n.modal-footer {\n  border: none;\n}\n\n.modal-title {\n  //color: #d40000;\n}\n\n.modal-body {\n  display: grid;\n  gap: 1.25rem;\n  text-align: center;\n}\n\n.modal-loader {\n  display: grid;\n  place-items: center;\n  min-height: 160px;\n}\n\n.modal-reward {\n  position: relative;\n  padding: 1rem;\n}\n\n.modal-reward__image {\n  width: min(220px, 70%);\n  margin: 0 auto 1rem;\n  display: block;\n}\n\n.modal-reward__title {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal-reward__desc {\n  font-size: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.modal-reward__cta {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.modal-nowin-copy {\n  font-size: 1.1rem;\n  //color: #333;\n}\n\n.modal-nowin .modal-title,\n.modal-nowin .modal-reward__title {\n  //color: #1f1f1f;\n}\n\n.modal-backdrop {\n  z-index: 1050;\n}\n\n.confetti {\n  pointer-events: none;\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 20%, rgba(212, 0, 0, 0.2), transparent 50%),\n    radial-gradient(circle at 80% 30%, rgba(255, 204, 0, 0.2), transparent 55%),\n    radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.3), transparent 55%);\n  mix-blend-mode: screen;\n  animation: confettiPulse 2.4s infinite;\n}\n\n@keyframes confettiPulse {\n  0%,\n  100% {\n    opacity: 0.4;\n  }\n\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.game-container {\n    video {\n        width: 100%;\n        height: 600px;\n    }\n\n    .play {\n        position: absolute;\n        left: 0;\n        right: 0;\n        width: 200px;\n        margin: 0 auto;\n        bottom: 90px;\n        z-index: 900;\n    }\n}\n\n\n@media (max-width: 767px) { \n    .game-container {\n        // video {\n        //     width: 100%;\n        //     height: auto;\n        // }\n\n        video {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%,-50%);\n            width: auto;\n            height: auto;\n            width: 100% !important;\n            height: auto !important;\n            z-index: 500;\n        }\n    }\n    \n\n}\n\n@media (max-width: 1024px) {\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
